import { render, staticRenderFns } from "./ModalList.vue?vue&type=template&id=75b9a47a&scoped=true"
import script from "./ModalList.vue?vue&type=script&lang=js"
export * from "./ModalList.vue?vue&type=script&lang=js"
import style0 from "./ModalList.vue?vue&type=style&index=0&id=75b9a47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b9a47a",
  null
  
)

export default component.exports